// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__m-8B2","content":"RecentSearches_content__15CB5"};